/**
 * @returns true if Date(a) > Date(b)
 */
export function compareDateString(a: string, b: string) {
    return (new Date(a).valueOf()) > (new Date(b).valueOf());
}